import { render } from "./Bar2Charts.vue?vue&type=template&id=c4472f6c&scoped=true"
import script from "./Bar2Charts.vue?vue&type=script&lang=js"
export * from "./Bar2Charts.vue?vue&type=script&lang=js"

import "./Bar2Charts.vue?vue&type=style&index=0&id=c4472f6c&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/bigdatadisplaysystem_php_master/front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4472f6c"]])

export default __exports__